import { gql } from "apollo-boost";
import { WarningAddressFragment } from "../fragments";

export const GET_WARNING_ADDRESSES = gql`
  query getWarningAddresses($filter: WarningAddressFilter!) {
    getWarningAddresses(filter: $filter) {
      total
      nodes {
        ...WarningAddressFragment
      }
    }
  }
  ${WarningAddressFragment}
`;


export const GET_WARNING_ADDRESS = gql`
  query getWarningAddress($id: ID!) {
    getWarningAddress(id: $id) {
      ...WarningAddressFragment
    }
  }
  ${WarningAddressFragment}
`;